<template>
	<div class="mPutiDetailCo">
		<div class="mVideoDetailMain">
			<div class="nNewsDetailHeader">
				<img class="backImg" @click="back" src="../../assets/mImg/mback.png" alt="">
				<div class="titleBox">菩提节详情</div>
			</div>
			<div class="mVideoMiddle">
				<div class="videoHeader" :class="this.$route.query.videoUrl == null ? 'none' : 'block'"
					v-html="videoDetails">
				</div>

				<div class="newsMainMiddle">
					<div class="newsTitle1">{{contentText.title}}</div>
					<div class="newsDate">{{contentText.create_time}}</div>
					<!-- <p class="fuContent" v-html="contentText.content"></p> -->
				</div>
			</div>
		</div>

		<div class="footerBoxMain">
			<div class="footerBoxMainMiddle">
				<div class="footerBoxTitle">快捷导航</div>
				<div class="bottomNavFirst bottomNav1">
					<div class="mHomeName">
						<router-link to="/m" tag="a">首页</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mDynamicLanshu" tag="a">菩提基金会</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav2">
					<div class="mHomeName">
						<router-link to="/maboutLansu" tag="a">关于兰树</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mhuaibrand" tag="a">兰树品牌</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav3">
					<div class="mHomeName">
						<router-link to="/mbrandLansu" tag="a">美业菩提</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mTrends" tag="a">兰树动态</router-link>
					</div>
				</div>
				<div class="footerBoxTitle footerBoxTitle2">联系我们</div>
				<div class="contactFirst contactFirst1">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/emailIcon.png" alt="">
					</div>
					<div class="contactContent">
						邮箱：postermaster@lasur.com
					</div>
				</div>
				<div class="contactFirst contactFirst2">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/phoneIcon.png" alt="">
					</div>
					<div class="contactContent">
						电话：0571-89025888
					</div>
				</div>
				<div class="contactFirst contactFirst3">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/gpsIcon.png" alt="">
					</div>
					<div class="contactContent">
						浙江省杭州市之江东路越秀·维多利中心A座 17楼
					</div>
				</div>
			</div>
			<div class="bottomLine"></div>
			<div class="codeBoxMain">
				<div class="footerBoxHeaderLeft">
					<img class="codeImg" src="../../assets/code.png" alt="">
					<span class="codeText">兰树公众号</span>
				</div>
				<div class="footerBoxHeaderRight">
					<img class="codeImg" src="../../assets/xcxNew.jpg" alt="">
					<span class="codeText">兰树云小程序</span>
				</div>
			</div>
			<div class="footerBoxBottom">
				<div class="footerLeft">
					Copyright © 2023 兰树化妆品股份有限公司
				</div>
				<div class="footerLeft">
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a><br />
					<img
						src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-13_13-29-23_21054.png" /><a
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
						33052102000740号</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { myGet, myPost, login } from "../../api/http.js";
export default {
	data() {
		return {
			videoDetails: '',
			contentText: [],
			config2: {
				id: 'mse2',
				url: '',
				volume: 1,
				autoplay: false,
			},
			Player2: null
		}
	},
	created() {
		this.gitDetails();
		this.playVideo();
	},
	methods: {
		gitDetails() {
			let that = this;
			let userId = this.$route.query.userId;
			myPost("api/messages/", {
				id: userId,
			}).then((res) => {
				console.log("res", res.data)
				that.contentText = res.data
				if (res.data.code == 200) {

				}
			});
		},

		// 视频
		playVideo() {
			let that = this;
			let videoUrl = that.$route.query.videoUrl;
			// this.config2.url = videoUrl;
			// console.log('video',123);
			that.config2.url = videoUrl;


			this.videoDetails = `<video
						 					  id="threeMyVideo"
						 					  class="video-js vjs-big-play-centered vjs-fluid"
						 					  controls
						 					  preload="auto"
						 					  width="100%"
						 					  height="100%"
						 					  poster=""
						 					>
						 						<source
						     type="application/x-mpegURL"
						     src="` + videoUrl + `"
						    >
						 					</video>`
			//此处初始化的调用，我放在了获取数据之后的方法内，而不是放在钩子函数mounted
			//页面dom元素渲染完毕，执行回调里面的方法
			this.videoHeight = window.innerHeight;
			//请求视频资源后关闭	 Banner
			setTimeout(() => {
				this.isBanner = false;
				this.isVideo = true;
			}, 2000)
			this.$nextTick(() => {
				let myPlayer = this.$video(document.getElementById('threeMyVideo'), {
					//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
					controls: true,
					muted: true,
					//自动播放属性,muted:静音播放
					autoplay: true,
					//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
					preload: "auto",
					loop: true,
					//设置视频播放器的显示宽度（以像素为单位）
					// width: "800px",
					//设置视频播放器的显示高度（以像素为单位）
					// height: "400px",
					controlBar: {
						playToggle: true
					}
				});
			});
			// myPost("api/messages/", {
			//   id: that.$route.query.userId,
			// }).then((res) => {
			// 	console.log("userId",res.data);

			// });	  
		},
		back() {
			this.$router.back(-1)
		}
	}
}
</script>

<style scoped>
.mPutiDetailCo {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}


.mVideoDetailMain {
	width: 90%;
	display: flex;
	flex-direction: column;
	padding-bottom: 1rem;
}


.mVideoMiddle {
	width: 100%;
	display: flex;
	flex-direction: column;
	background: #FFFFFF;
	margin: 0 auto;
	margin-top: 1rem;
}



.newsMainMiddle {
	width: 100%;
	display: flex;
	flex-direction: column;
	background: #FFFFFF;
	margin: 0 auto;
	margin-top: 1rem;
}

.fuContent {
	margin: 0 auto;
}



.newsTitle1 {
	width: 100%;
	font-size: 1rem;
	color: #222222;
}

.newsTitle2 {
	width: 100%;
	margin: 0 auto;
	text-align: center;
	font-size: 0.875em;
	color: #222222;
	line-height: 19px;
	margin-top: 1em;
}

.newsDate {
	font-size: 0.75em;
	color: #999999;
	line-height: 16px;
	margin-top: 0.5em;
}

.nNewsDetailHeader {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 0.5rem;
}

.backImg {
	width: 1.5rem;
}

.titleBox {
	color: #222222;
	font-size: 1.1rem;
	text-align: center;
}


.footerFirstLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 1rem;
}

.footerSecondLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 0.5rem;
}

.footerItem {
	list-style: none;
}

.footerItem a {
	color: #333333;
	font-size: 0.9375rem;
	text-decoration: none;
	margin-left: 0.5rem;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9375em;
	color: #333333;
	line-height: 28px;
	margin-left: 1rem;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.9375rm;
	color: #333333;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerBoxHeader {
	width: 60%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}



.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.emailBox {
	font-size: 0.875rem;
	color: #333333;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	color: #333333;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	color: #333333;
	line-height: 20px;
	margin-top: 0.5rem;
	text-align: center;
}

.footerLine {
	width: 100%;
	height: 1px;
	display: flex;
	background: #333333;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}


.block {
	display: block;
	width: 100%;
}

.none {
	display: none;
	width: 100%;
}


.footerBoxMainMiddle {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
}

.footerBoxTitle {
	color: #FFFFFF;
	font-size: 1rem;
	font-weight: 500;
}

.bottomNavFirst {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.mHomeName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.ptjjhName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.contactFirst {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.contactImgBox {
	width: 0.8rem;
}

.contactImg {
	width: 100%;
}

.contactContent {
	color: #FFFFFF;
	font-size: 0.7rem;
	opacity: 0.7;
	margin-left: 0.5rem;
}

.bottomLine {
	width: 100%;
	height: 2px;
	background: #FFFFFF;
	opacity: 0.1;
	margin-top: 1.5rem;
}

.footerBoxTitle2 {
	margin-top: 1.5rem;
}

.contactFirst1 {
	margin-top: 1rem;
}

.codeBoxMain {
	width: 50%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	margin-top: 1.5rem;
}


.codeImg {
	width: 80%;
}

.codeText {
	font-size: 0.5em;
	color: #FFFFFF;
	line-height: 20px;
	opacity: 0.7;
	/* margin-top: 0em; */
}

.footerBoxMain {
	width: 100%;
	background-color:  #2c5eff;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 1rem;
}

.footerLeft {
	text-align: center;
	font-size: 0.9em;
	color: #FFFFFF;
	line-height: 24px;
	opacity: 0.7;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #FFFFFF;
	opacity: 0.7;
}

.contactFirst2 {
	margin-top: 0.5rem;
}

.contactFirst3 {
	margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mComponents/mPutiDetail.vue